const FETCH_VANHOA_CHAPTERS = "FETCH_VANHOA_CHAPTERS";
const FETCH_VANHOA_LESSONS = "FETCH_VANHOA_LESSONS";
const FETCH_VANHOA_QUIZZES = "FETCH_VANHOA_QUIZZES";
const FETCH_VANHOA_EXAMS = "FETCH_VANHOA_EXAMS";
const FETCH_VANHOA_QUESTIONS = "FETCH_VANHOA_QUESTIONS";
const FETCH_VANHOA_QUIZ_QUESTIONS = "FETCH_VANHOA_QUIZ_QUESTIONS";
const SUBMIT_VANHOA_EXAM = "SUBMIT_VANHOA_EXAM";
const SUBMIT_VANHOA_QUIZ = "SUBMIT_VANHOA_QUIZ";
const FETCH_VANHOA_EXAM_QUESTIONS = "FETCH_VANHOA_EXAM_QUESTIONS";
const FETCH_VANHOA_EXAM_SOLUTION = "FETCH_VANHOA_EXAM_SOLUTION";
const FETCH_VANHOA_EXAM_CONTEXTS = "FETCH_VANHOA_EXAM_CONTEXTS";

const initialState = {
  chapters: [],
  lessons: [],
  quizzes: [],
  exams: [],
  questions: [],
  quizQuestions: [],
  examQuestions: [],
  examFillQuestions: [],
  examSolution: {},
  vanhoaExamContexts: [],
  submitResult: null,
};

export default function vanhoaReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_VANHOA_CHAPTERS:
      return {
        ...state,
        chapters: action.payload,
      };

    case FETCH_VANHOA_LESSONS:
      return {
        ...state,
        lessons: action.payload,
      };

    case FETCH_VANHOA_QUIZZES:
      return {
        ...state,
        quizzes: action.payload,
      };

    case FETCH_VANHOA_EXAMS:
      return {
        ...state,
        exams: action.payload,
      };

    case FETCH_VANHOA_QUESTIONS:
      return {
        ...state,
        questions: action.payload,
      };

    case FETCH_VANHOA_QUIZ_QUESTIONS:
      return {
        ...state,
        quizQuestions: action.payload,
      };

    case SUBMIT_VANHOA_EXAM:
      return {
        ...state,
        submitResult: action.payload,
      };

    case SUBMIT_VANHOA_QUIZ:
      return {
        ...state,
        submitResult: action.payload,
      };

    case FETCH_VANHOA_EXAM_QUESTIONS:
      return {
        ...state,
        examQuestions: action.payload,
      };

    case FETCH_VANHOA_EXAM_SOLUTION:
      return {
        ...state,
        examSolution: action.payload,
      };

    case "FETCH_VANHOA_EXAM_FILL_QUESTIONS":
      return {
        ...state,
        examFillQuestions: action.payload,
      };

    case FETCH_VANHOA_EXAM_CONTEXTS:
      return {
        ...state,
        vanhoaExamContexts: action.payload,
      };

    default:
      return state;
  }
}